import React, { useEffect, useState, FC, useMemo } from "react";
import { Platform, ScrollView, StyleSheet, Text, View, useWindowDimensions } from "react-native";
import Colors from "../../resources/Colors.ts";
import { useAppDispatch, useAppSelector } from "../../store/hooks.ts";
import { getTwilioTokenAndGo, updateNameContact, getTemplate } from "../../controller/chatController.ts";
import { getUsersAction } from "../../controller/usersController.ts";
import { Badge, Button, Chip, Dialog, IconButton, List, Searchbar } from "react-native-paper";
import { IRoute } from "src/interfaces";
import { ChatScreen } from "./ChatScreen.web.tsx";
import GlobalStyles from "../../resources/Styles.ts";
import { Client } from '@twilio/conversations';
import SelectField from '../../components/Form/SelectField';
import { CecyIA } from "../../utils/constants.js";
import { setSchedules, setUsers } from "../../store/slices/userSlice.ts";
import { setUserInfo } from "../../store/slices/authSlice.ts";
import { loadingMessage, showLoadingChat } from "../../store/slices/alertsSlice.ts";
import { getUserInfo } from "../../controller/authController.ts";


export const AgencyChatsScreen: FC<IRoute> = ({ route, navigation }) => {
  const { height } = useWindowDimensions();

  const dispatch = useAppDispatch();
  const chat = useAppSelector(state => state.chat);
  const auth = useAppSelector(state => state.auth);
  const user = useAppSelector(state => state.user);

  const [loading, setLoading] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [channel, setChannel] = useState(null);
  const [twilioClient, setTwilioClient] = useState(null);
  const [userFilter, setUserFilter] = useState("");

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredConversations, setFilteredConversations] = useState([]); // La lista que se renderiza
  const [filteredUserConv, setFilteredUserConv] = useState([]); // La lista que se renderiza
  const [activeFilter, setActiveFilter] = useState('all'); // 'all', in_progress, generating, error_handoff, manual_pause
  const [lastAuthorMap, setLastAuthorMap] = useState({});

  const [showDialog, setShowDialog] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [nameContact, setNameContact] = useState(null);
  const [showRename, setShowRename] = useState(false);
  const [children, setChildren] = useState(null);

  const [conversations1, setConversations1] = useState([]);
  const [conversations2, setConversations2] = useState([]);

  const conteos = useMemo(() => {
    return filteredUserConv.reduce((acc, conv) => {
      const status = conv._internalState?.attributes?.cecy_status || 'sin_estado';
      acc[status] = (acc[status] || 0) + 1;
      acc['Todos'] = (acc['Todos'] || 0) + 1;
      return acc;
    }, { Todos: 0 });
  }, [filteredUserConv]);

  useEffect(() => {
    const setupNotifications = async () => {
      // Solo ejecutamos si el sistema operativo es 'web'
      if (Platform.OS === 'web') {
        if (Platform.OS === 'web') {
          if (!("Notification" in globalThis)) {
            console.error("Este navegador no soporta notificaciones.");
            return;
          }

          if (globalThis.Notification.permission !== "granted") {
            await globalThis.Notification.requestPermission();
          }

        }
      }
    };

    setupNotifications();
    
    if(!channel){
      setUserFilter(auth.userInfo?.role === "admin" ? "" : auth.userInfo?.id)
    }

    if (!loading && auth.userInfo) {
      setLoading(true);
      dispatch(getTwilioTokenAndGo("bot", auth.userInfo?.group_id));
      dispatch(getTemplate(auth.userInfo?.group_id));
      dispatch(getUsersAction(auth.userInfo?.group_id));
      loadChatsNotJoined();
    }
  }, [auth.userInfo]);

  useEffect(() => {
    if (!auth.userInfo) { // Cambié !auth por !auth.userInfo para ser más preciso
      console.log("Sesión finalizada, cerrando Twilio...");
      disconnectTwilioClient();
    }
  }, [auth.userInfo]);

  const lanzarNotificacion = (message, typeError: Boolean = false) => {
    if (globalThis.Notification.permission === "granted") {
      let notification;

      if (typeError) {
        notification = new Notification("Cecy IA", {
          body: "⚠️ Error técnico: No se pudo generar la cotización.",
          silent: false, // Asegura que suene
        });
      } else {
        notification = new Notification("Cecy IA", {
          body: "Nuevo Mensaje",
          silent: false, // Asegura que suene
        });
      }

      // Al hacer clic en la notificación, vuelve a la pestaña del chat
      notification.onclick = () => {
        globalThis.focus();
        notification.close();
      };
    }
  };


  useEffect(() => {
    if (chat.twilioToken) {
      activeTwilio()
      //setLoading(true);
      dispatch(showLoadingChat(true));
      dispatch(loadingMessage('Cargando conversaciones'));
    }
  }, [chat.twilioToken]);

  useEffect(() => {
    let result = conversations;
    const lowerCaseSearch = searchTerm.toLowerCase();

    if (userFilter) {
      result = result.filter(c => {
        return c._internalState?.attributes.broker_id === userFilter ||
          (userFilter === CecyIA && (c._internalState?.attributes.broker_id === CecyIA || !Object.hasOwn(c._internalState?.attributes, 'broker_id')));
      });
    }

    setFilteredUserConv(result);

    if (activeFilter !== 'all') {
      result = result.filter(c => {
        // ... (Toda la lógica del switch/case para 'attended', 'unanswered', 'unattended')
        // 🛑 LECTURA ASÍNCRONA: Obtener el autor del mapa (cache)
        const lastAuthor = lastAuthorMap[c.sid];

        // Si el autor aún no se ha cargado (es undefined), mantenemos el chat en la lista
        if (lastAuthor === undefined) return true;

        const filterAttribute = c._internalState?.attributes?.cecy_status;

        switch (activeFilter) {
          case 'in_progress':
          case 'generating':
          case 'error_handoff':
          case 'manual_pause':
            return filterAttribute === activeFilter;
          default:
            return true;
        }
      });
    }

    // // 2. 🛑 APLICAR FILTRO POR TÉRMINO DE BÚSQUEDA (El nuevo filtro mientras escribes)
    if (searchTerm) {
      result = result.filter(c => {
        return c._internalState.uniqueName.toLowerCase().includes(lowerCaseSearch) ||
          c._internalState.friendlyName.toLowerCase().includes(lowerCaseSearch);
      });
    }

    setFilteredConversations(result);

    // Este hook se re-ejecuta cada vez que cambias el término o el filtro de estado
  }, [conversations, searchTerm, activeFilter, lastAuthorMap, userFilter]);

  const fetchLastMessageAuthor = async (partialConversation) => {
    if (partialConversation.lastMessage < 0) return null;

    try {
      const lastMessage = await partialConversation.getMessages(1, partialConversation.lastMessage.index);

      // 3. Extraer el autor
      return lastMessage ? lastMessage.items[0].author : null;

    } catch (error) {
      console.error(`Error fetching last message for ${partialConversation.sid}:`, error, error.message);
      // El error 'getMessageByIndex is not a function' debería desaparecer
      return null;
    }
  };

  // 🛑 useEffect para llenar el lastAuthorMap
  useEffect(() => {
    const fetchAllAuthors = async () => {
      const authorPromises = conversations.map(async (conv) => {
        // Solo buscar si aún no está en el mapa
        if (lastAuthorMap[conv.sid] === undefined) {
          const author = await fetchLastMessageAuthor(conv);
          return [conv.sid, author];
        }
        return [conv.sid, lastAuthorMap[conv.sid]];
      });

      const authors = await Promise.all(authorPromises);
      const newMap = Object.fromEntries(authors.filter(([sid, author]) => author !== undefined));

      // Actualiza el mapa con los nuevos autores encontrados
      setLastAuthorMap(prev => ({ ...prev, ...newMap }));
    };

    // 🛑 Condición de ejecución: Solo si tenemos el Cliente y conversaciones
    if (conversations.length > 0) {
      fetchAllAuthors();
    }

    // Cambiar el objeto channerl cuando cambia el nombre del contacto
    if (channel) {
      const channelTemp = conversations.find(x => x.sid === channel.sid)
      if (channelTemp) {
        setChannel({
          sid: channelTemp?.sid,
          orgId: channelTemp._internalState?.attributes?.org_id,
          user: getUser(channelTemp._internalState.uniqueName, channelTemp._internalState.friendlyName, true),
          letter: getUser(channelTemp._internalState.uniqueName, channelTemp._internalState.friendlyName)[0],
          number: getNumber(channelTemp._internalState.uniqueName),
          whatsapp: channelTemp._internalState?.attributes?.whatsapp_number,
          twilioClient: channelTemp.customClient,
          brokerId: channelTemp._internalState?.attributes?.broker_id || CecyIA,
          attributes: channelTemp._internalState?.attributes,
        })
      }
    }
    // Se ejecuta cada vez que la lista de conversaciones cambia
  }, [conversations]);

  useEffect(() => {
    let initialChannels = sortConversationsByLastMessage(conversations1.concat(conversations2));
    setConversations(initialChannels)
  }, [conversations1, conversations2])

  const userList = () => {
    const item = { id: CecyIA, name: "Sin asignar", email: "cecyia@ensitech.com", is_active: true };
    const itemUsers = [item, ...user.users];

    return itemUsers.map((user: any) => {
      return { value: user.id, label: user.name };
    });
  }

  // Función para actualizar el estado de React de forma segura
  const loadConversationList = (newConversations, index) => {
    if (index) {
      setConversations1(newConversations)
    } else {
      setConversations2(newConversations)
    }
  };

  // Recibirá el objeto de la conversación actualizado (del evento o del get)
  const updateAndReorderConversation = (updatedChannel) => {
    setConversations(prevChats => {
      // 1. Encuentra el índice y el objeto de la conversación antigua
      const index = prevChats.findIndex(c => c.sid === updatedChannel.sid);

      // Si la conversación no existe, simplemente la agregamos al inicio (caso nuevo)
      if (index === -1) {
        // El caso ideal es que Twilio la agregue con 'channelAdded'
        return [updatedChannel, ...prevChats];
      }

      // 2. Crea una NUEVA lista SIN la conversación antigua (inmutabilidad)
      // Usa slice() para crear una copia del array sin el elemento en el índice encontrado
      const chatsWithoutOld = [
        ...prevChats.slice(0, index),
        ...prevChats.slice(index + 1),
      ];

      // 3. Mueve la conversación actualizada al inicio
      // Al usar el objeto 'updatedChannel', garantizas que tienes la info más reciente
      return [updatedChannel, ...chatsWithoutOld];
    });
  };

  // Función de ayuda para ordenar por fecha de último mensaje
  const sortConversationsByLastMessage = (conversations) => {
    return conversations.sort((a, b) => {
      // Usa la propiedad 'dateCreated' del último mensaje (es un objeto Date)
      // Si no hay mensaje, usa una fecha antigua (new Date(0))
      const timeA = a.lastMessage?.dateCreated || new Date(0);
      const timeB = b.lastMessage?.dateCreated || new Date(0);

      // Resta para ordenar DESCENTENTE (más nuevo [b] primero)
      return timeB.getTime() - timeA.getTime();
    });
  };

  // Esta función carga las conversaciones y actualiza el estado 'conversations'
  const loadAndSetConversations = async (client, index) => {
    // Aquí iría tu lógica original de client.getSubscribedConversations()
    try {
      let allConversations = [];
      let paginator = await client.getSubscribedConversations();
      // Mapeamos los items para que cada conversación tenga una referencia al cliente
      let initialChannels = paginator.items.map(conv => {
        conv.customClient = client; // <--- Inyección manual
        return conv;
      });

      // 🚀 PASO CLAVE: Ordenar la lista ANTES de guardarla en el estado
      // Agregamos la primera página
      allConversations = allConversations.concat(initialChannels);
      loadConversationList(allConversations, index); // Esto actualiza setConversations

      while (paginator.hasNextPage) {
        paginator = await paginator.nextPage();
        initialChannels = paginator.items.map(conv => {
          conv.customClient = client; // <--- Inyección manual
          return conv;
        });
        allConversations = allConversations.concat(initialChannels);
        loadConversationList(allConversations, index); // Esto actualiza setConversations
      }

    } catch (error) {
      console.error("Error al cargar conversaciones:", error);
    }
  }

  // 🚀 Implementación de la función de cierre de sesión de Twilio
  const disconnectTwilioClient = async () => {
    if (twilioClient) {
      try {
        console.log("Cerrando la conexión de Twilio...");
        await twilioClient.shutdown(); // Llama al método de desconexión

        // Limpiar el estado después de un cierre exitoso
        setTwilioClient(null);
        setConversations([]);
        setChannel(null);
        setSchedules([]);
        setUserInfo(null);
        setUsers([])

        console.log("Conexión de Twilio cerrada exitosamente.");
      } catch (error) {
        console.error("Error al cerrar la conexión de Twilio:", error);
      }
    }
  };


  const activeTwilio = async () => {
    // Verificamos que tengamos tokens
    const tokens = Array.isArray(chat.twilioToken) ? chat.twilioToken : [chat.twilioToken];

    // Limpiamos el listado antes de empezar si es necesario
    setConversations([]);

    for (const [index, token] of tokens.entries()) {
      try {
        // Forzamos un aislamiento total
        const client = new Client(token, {
          storage: 'none',
          // Esto es clave: evitamos que el SDK intente registrar workers que colisionen
          useWebRTC: false
        });

        // Configuramos el listener de errores ANTES de la promesa
        client.on('initFailed', (error) => {
          console.error(`Fallo crítico en cuenta ${index}:`, error.message);
          dispatch(getTwilioTokenAndGo("bot", auth.userInfo?.group_id));
        });

        await new Promise((resolve, reject) => {
          const timeout = setTimeout(() => resolve(null), 10000); // Timeout de seguridad

          client.on('initialized', async () => {
            clearTimeout(timeout);

            // Cargamos las conversaciones de esta cuenta específica
            await loadAndSetConversations(client, index);

            // Escuchamos nuevos canales para esta cuenta
            client.on('channelAdded', (channel) => {
              setConversations(prev => [channel, ...prev]);
            });

            resolve(client);
          });

          // client.on('initFailed', () => {
          //   clearTimeout(timeout);
          //   resolve(null); // No usamos reject para que el bucle siga con el siguiente token
          // });

          client.on('conversationUpdated', ({ conversation, updateReasons }) => {
            // Verificamos si la razón del cambio fue la modificación de atributos
            if (updateReasons.includes('attributes')) {

              if (conversation?.attributes?.cecy_status === "error_handoff") {
                lanzarNotificacion("update", true)
              }
            }
          });

          // Y lo asignas:
          client.on('messageAdded', handleGlobalMessage);

          client.on('tokenAboutToExpire', async () => {
            console.log("Renovando sesión de Twilio...");

            try {
              // Invocamos la acción y esperamos el nuevo token
              const newToken = await dispatch(getTwilioTokenAndGo("bot", auth.userInfo?.group_id));

              if (newToken) {
                // Aplicar el nuevo token al cliente de Twilio sin desconectar
                await client.updateToken(newToken);
                console.log("Token de Twilio actualizado correctamente.");
              }
            } catch (err) {
              console.error("Error crítico al renovar el token:", err);
            }
          });

          client.on('tokenExpired', () => {
            console.warn("El token ha expirado. Intentando reconexión forzada...");
            // Aquí lo más seguro es reiniciar el flujo de twilio
            dispatch(getTwilioTokenAndGo("bot", auth.userInfo?.group_id));
            activeTwilio();
          });

        });

        // Espera obligatoria de 1 segundo entre cuentas para que el socket respire
        await new Promise(r => setTimeout(r, 1000));

        dispatch(showLoadingChat(false));
        //setLoading(false)

      } catch (err) {
        console.error(`Error inesperado en iteración ${index}:`, err);
      }
    }
  };

  // Dentro de activeTwilio, define la función así:
  const handleGlobalMessage = async (message) => {

    if (message.conversation?.customClient && message.author !== message.conversation?.customClient?.user?.identity) {
      lanzarNotificacion(message.body);
    }

    const updatedConversation = message.conversation;
    updateAndReorderConversation(updatedConversation);
  };

  const openImageModal = (imageUrl: string, editName: boolean = false, content: object | null = null) => {
    setShowRename(editName);

    if (!content) {
      if (!editName) {
        // 1. Guarda la URL de la imagen
        setCurrentImage(imageUrl);
        // 2. Muestra el modal
      } else {
        setNameContact(imageUrl)
      }
    } else {
      setChildren(content);
    }
    setShowDialog(true);
  };

  // Función para cerrar (necesitas una)
  const closeImageModal = () => {
    setShowDialog(false);
    setCurrentImage(null);
    setNameContact(null);
    setShowRename(false);
  };

  const renameContact = async () => {
    let result = await updateNameContact({
      conversation_sid: channel?.sid,
      friendly_name: nameContact,
      org_id: channel?.orgId,
      whatsapp_number: channel?.whatsapp,
    });

    if (result) {
      // 1. Actualizamos la lista lateral (conversations)
      setConversations(prev => prev.map(conv => {
        if (conv.sid === channel.sid) {
          // Clonamos la conversación y actualizamos el friendlyName
          return {
            ...conv,
            _internalState: {
              ...conv._internalState,
              friendlyName: nameContact
            }
          };
        }
        return conv;
      }));

      // 2. ACTUALIZACIÓN CRÍTICA: Forzamos un nuevo objeto de canal
      setChannel(prev => ({
        ...prev,
        user: nameContact, // El nuevo nombre
        letter: nameContact[0], // La nueva letra para el avatar
      }));

      closeImageModal();
    }
  };

  const updateConversationAttributes = (sid, newAttributes) => {
    setConversations(prev => prev.map(conv => {
      if (conv.sid === sid) {
        // Importante: Clonamos la estructura interna de Twilio para que React note el cambio
        return {
          ...conv,
          _internalState: {
            ...conv._internalState,
            attributes: {
              ...conv._internalState.attributes,
              ...newAttributes // Aquí entraría el nuevo brokerId
            }
          }
        };
      }
      return conv;
    }));

    // 2. Actualizamos el 'channel' activo para que el Hijo (ChatScreen) reciba la nueva prop
    setChannel(prev => {
      if (prev?.sid === sid) {
        return {
          ...prev,
          brokerId: newAttributes.broker_id || newAttributes.brokerId, //|| prev.brokerId,
          attributes: { ...prev.attributes, ...newAttributes }
        };
      }
      return prev;
    });
  };

  const loadChatsNotJoined = () => {
    setLoading(true);
  }

  const getNumber = (numberUser: string) => {
    return numberUser.replace("conv:whatsapp:", "")
  }

  const getUser = (numberUser: string, friendlyName: string, onlyNumber: boolean = false) => {
    let name = "";
    let word = "conv:";

    name = numberUser.replace(word, "")

    if (name === friendlyName) {
      if (onlyNumber) {
        word += "whatsapp:"
        name = numberUser.replace(word, "")
      }
    } else
      name = friendlyName

    return name;
  }

  const RenderDescription = (agency: any) => {
    return (<View style={styles.descriptionContainer}>
      {!agency.agency?.attributes?.human_supervisor &&
        (<Chip
          mode="flat"
          selectedColor="white"
          style={styles.statusChip}
          textStyle={styles.chipText}
        >
          AI
        </Chip>)}
      <Text style={styles.agentName}>{getBroker(agency.agency?.attributes?.broker_id || CecyIA)}</Text>
    </View>
    )
  };

  const getBroker = (id: number) => {
    if (id == 0) {
      id = CecyIA;
    }
    return user.users.find(x => x.id === id)?.name
  }

  const formatLastMessageDate = (date) => {
    if (!date) return "";

    const msgDate = new Date(date);
    const today = new Date();

    // Comparamos si es el mismo día, mes y año
    const isToday =
      msgDate.getDate() === today.getDate() &&
      msgDate.getMonth() === today.getMonth() &&
      msgDate.getFullYear() === today.getFullYear();

    if (isToday) {
      // Si es hoy: Retorna HH:MM (ejemplo: 14:30)
      return msgDate.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    } else {
      // Si es otro día: Retorna DD/MM/AAAA (ejemplo: 15/03/2024)
      return msgDate.toLocaleDateString([], {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  };

  const renderItem = (agency: any, index: number) => {
    // 1. OBTENER LOS ÍNDICES PERSISTIDOS
    const lastMessageIndex: number = agency.lastMessage
      ? agency.lastMessage.index
      : -1;
    // lastReadMessageIndex es la clave que persiste el estado de lectura.
    const lastReadIndex: number = agency.lastReadMessageIndex || -1;
    // 2. CALCULAR EL CONTADOR LOCAL
    const unreadCount: number = Math.max(0, lastMessageIndex - lastReadIndex);

    // 1. Detectamos si este es el canal seleccionado
    const isSelected = channel?.sid === agency.sid;

    return (
      <List.Item
        key={`agencyChat-${index}`}
        // 2. Aplicamos el color de fondo condicionalmente
        style={{
          paddingHorizontal: 0,
          backgroundColor: isSelected ? '#ECEBFE' : 'transparent', // <--- AQUÍ EL CAMBIO
          borderRadius: 10,
        }}
        titleStyle={{
          fontSize: 14,
          marginLeft: -10,
          width: '100%',
          fontWeight: isSelected ? 'bold' : 'normal', // Opcional: poner el texto en negrita si está seleccionado
        }}
        title={getUser(
          agency._internalState.uniqueName,
          agency._internalState.friendlyName,
          true,
        )}
        description={() => (
          <RenderDescription
            style={{marginLeft: -10}}
            agency={agency._internalState}
          />
        )} // Pasamos el componente aquí
        left={() => (
          <View
            style={{
              width: 30,
              height: 30,
              borderRadius: 15,
              borderStyle: 'solid',
              backgroundColor: Colors.greenButtonColor,
              justifyContent: 'center',
              marginLeft: 10,
            }}>
            <Text style={{fontSize: 16, textAlign: 'center'}}>
              {
                getUser(
                  agency._internalState.uniqueName,
                  agency._internalState.friendlyName,
                )[0]
              }
            </Text>
          </View>
        )}
        right={() => (
          <View style={[styles.rightContainer, {marginRight: 0}]}>
            <Text style={{fontSize: 12, color: 'gray', marginRight: 5}}>
              {formatLastMessageDate(
                agency.lastMessage?.dateCreated || agency.dateUpdated,
              )}
            </Text>
            {/* 🛑 3. BADGE: Se muestra solo si unreadCount es > 0 */}
            {unreadCount > 0 && (
              <Badge size={5} style={styles.badgeStyle}></Badge>
            )}
            {/* 2. ICONO: Siempre visible (o según tu lógica) */}
            <List.Icon icon="chevron-right" style={styles.chevronIcon} />
          </View>
        )}
        onPress={async () => {
          dispatch(getUserInfo());
          setChannel({
            sid: agency.sid,
            user: getUser(
              agency._internalState.uniqueName,
              agency._internalState.friendlyName,
              true,
            ),
            letter: getUser(
              agency._internalState.uniqueName,
              agency._internalState.friendlyName,
            )[0],
            number: getNumber(agency._internalState.uniqueName),
            attributes: agency._internalState?.attributes,
            orgId: agency._internalState?.attributes?.org_id,
            whatsapp: agency._internalState?.attributes?.whatsapp_number,
            twilioClient: agency.customClient,
            brokerId: agency._internalState?.attributes?.broker_id || CecyIA,
          });

          // 🛑 LLAMADA CLAVE: Persiste el valor de lectura en el servidor.
          try {
            await agency?.setAllMessagesRead();
          } catch (e) {
            console.error('Error al marcar como leído:', e);
          }
        }}
      />
    );
  };

  return (
    <View
      style={{
        flex: 1,
        //height: height - 55,
        backgroundColor: Colors.bgWhite,
        overflow: 'hidden',
      }}>

      <View style={[styles.container, { flex: 1 }]}>
        <View style={[styles.horizontalContentTop, { height: '100%' }]}>

          {/* COLUMNA IZQUIERDA: Lista de Chats (Ancho fijo) */}
          <View style={{ width: 320, height: '100%' }}>
            <List.Section style={{ flex: 1, marginHorizontal: 20, height: '100%' }}>
              <View style={{ marginVertical: 15 }}>
                <Text style={{ flex: 1, color: Colors.primary, fontSize: 30 }}>
                  Conversaciones
                </Text>
              </View>
              <List.Subheader
                style={{ padding: 0 }}
              >
                <Searchbar
                  style={[
                    styles.inputText, { paddingHorizontal: 10 }
                  ]}
                  placeholder="Buscar"
                  onChangeText={setSearchTerm}
                  value={searchTerm}
                  inputStyle={{ fontSize: 14, minHeight: 40 }}
                />
              </List.Subheader>
              <View style={[styles.filterContainer, { textAlignVertical: 'top', marginBottom: 5, alignItems: "anchor-center" }]}>
                <Text>Usuario: </Text>
                <SelectField name={'user'}
                  formValues={{ user: userFilter }}
                  items={userList()}
                  placeholder={'Todos'}
                  style={{ width: 200 }}
                  onUpdateFormValue={(name, value) => {
                    setUserFilter(value);
                  }} />
              </View>
              <View style={styles.filterContainer}>
                <Button
                  mode={activeFilter === 'all' ? 'contained' : 'outlined'}
                  onPress={() => setActiveFilter('all')}
                  style={styles.filterButton} // Aplicar estilo de espaciado
                  labelStyle={styles.filterLabel}
                >
                  Todos {conteos["Todos"] ? "(" + conteos["Todos"] + ")" : ""}
                </Button>

                {/* Botón "Atendidos" */}
                <Button
                  mode={activeFilter === 'in_progress' ? 'contained' : 'outlined'}
                  onPress={() => setActiveFilter('in_progress')}
                  style={styles.filterButton} // Aplicar estilo de espaciado
                  labelStyle={styles.filterLabel}
                >
                  Conversando {conteos["in_progress"] ? "(" + conteos["in_progress"] + ")" : ""}
                </Button>

                {/* Botón "Sin Respuesta" (Sin Res...) */}
                <Button
                  mode={activeFilter === 'generating' ? 'contained' : 'outlined'}
                  onPress={() => setActiveFilter('generating')}
                  style={styles.filterButton} // Aplicar estilo de espaciado
                  labelStyle={styles.filterLabel}
                >
                  Generando {conteos["generating"] ? "(" + conteos["generating"] + ")" : ""}
                </Button>
                <Button
                  mode={activeFilter === 'error_handoff' ? 'contained' : 'outlined'}
                  style={styles.filterButton} // Aplicar estilo de espaciado
                  labelStyle={styles.filterLabel}
                  onPress={() => setActiveFilter("error_handoff")}>Error Técnico {conteos["error_handoff"] ? "(" + conteos["error_handoff"] + ")" : ""}</Button>
                <Button
                  mode={activeFilter === 'manual_pause' ? 'contained' : 'outlined'}
                  style={styles.filterButton} // Aplicar estilo de espaciado
                  labelStyle={styles.filterLabel}
                  onPress={() => setActiveFilter("manual_pause")}>Pausadas {conteos["manual_pause"] ? "(" + conteos["manual_pause"] + ")" : ""}</Button>
              </View>
              <List.Subheader>Direct Messages</List.Subheader>
              <View style={{ flex: 1, minHeight: 0 }}>
                <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
                  {filteredConversations && filteredConversations.map((agency: any, index: number) => {
                    return renderItem(agency, index)
                  })}
                </ScrollView>
              </View>
            </List.Section >
          </View >

          <View style={{ flex: 1, height: '100%', minWidth: 0, paddingHorizontal: 10, paddingBottom: 10 }}>
            {chat.twilioToken && channel ?
              (<ChatScreen
                navigation={navigation}
                channel={channel}
                onDialog={openImageModal}
                onClose={closeImageModal}
                onUpdateAttributes={updateConversationAttributes} />) : null
            }
          </View>
        </View >
      </View >
      {showDialog && (
        <Dialog visible={showDialog} onDismiss={() => closeImageModal()} style={{ maxWidth: '100%', maxHeight: '100%', alignSelf: 'center' }}>
          <Dialog.Title>
            {showRename && (
              <Text>Renombrar Conversación</Text>
            )}
            <View style={{ alignItems: 'flex-end', width: '100%', position: 'absolute', top: -10, right: 0, zIndex: 10 }}>
              <IconButton icon={'close'} iconColor={Colors.bgBlue} onPress={() => closeImageModal()} />
            </View>
          </Dialog.Title>
          <Dialog.Content style={[(showRename ? styles.contentEdit : styles.contentImage), {
            paddingHorizontal: 0,
            paddingBottom: 0,
            paddingTop: 25,
            alignItems: "center",
            maxHeight: 'calc(100% - 60px)', // Deja espacio para el botón de cierre y algo de margen
            flexGrow: 1, // Permite que ocupe el espacio disponible
            justifyContent: 'center' // Centra la imagen verticalmente
          }]} >
            {children && (children)}
            {currentImage && (<img
              src={currentImage}
              alt="Imagen completa"
              style={{
                maxWidth: '95%',
                maxHeight: '95%',
                objectFit: 'contain', // Ajusta la imagen sin cortarla
              }}
              // Opcional: Detener la propagación para que hacer clic en la imagen no la cierre
              onClick={(e) => e.stopPropagation()}
            />)}
            {showRename && (<View style={{ width: "90%", marginBottom: 5 }}>
              <input
                type="text"
                value={nameContact}
                onChange={(e) => setNameContact(e.target.value)}
                placeholder="Ej. Honda Civic 2019"
                className="message-input"
              />
            </View>)}
          </Dialog.Content>
          {showRename && (
            <Dialog.Actions>
              <Button onPress={renameContact}>Guardar</Button>
            </Dialog.Actions>
          )}
        </Dialog>
      )}
    </View >
  );
};

const styles = StyleSheet.create({
  rightContainer: {
    // 🛑 Flexbox para la alineación horizontal y vertical
    flexDirection: 'row',
    alignItems: 'center', // Alinea verticalmente (centra)
    justifyContent: 'flex-end', // Empuja los elementos a la derecha
    //paddingRight: 5, // Pequeño padding para no pegar al borde
    minWidth: 60,
  },
  badgeStyle: {
    backgroundColor: 'red', // O theme.colors.primary
    color: 'white',
    minWidth: 20,
    height: 20,
    borderRadius: 10,
    marginRight: 10, // Espacio entre el badge y el chevron
  },
  chevronIcon: {
    // Si usas List.Icon, a veces tiene padding por defecto que hay que neutralizar
    margin: 0,
    padding: 0,
  },
  contentText: {
    flex: 1,
  },
  filterContainer: {
    // 🛑 CLAVE 1: Habilitar la disposición horizontal
    flexDirection: 'row',
    // 🛑 CLAVE 2: Permitir que los elementos salten a la siguiente línea
    flexWrap: 'wrap',
  },
  filterButton: {
    // 🛑 CLAVE 3: Añadir espacio después de cada botón
    marginRight: 8,
    marginBottom: 8, // Espacio entre las filas cuando salta de línea (wrap)
    height: 32
  },
  filterLabel: {
    lineHeight: 12,
    marginHorizontal: 8
  },
  contentEdit: {
    width: 380
  },
  contentImage: {
    width: "100%"
  },
  descriptionContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
  },
  statusChip: {
    //backgroundColor: '#4CAF50', // Verde para estatus
    backgroundColor: Colors.bgBlue,
    height: 24,
    marginRight: 8,
  },
  chipText: {
    fontSize: 10,
    lineHeight: 12,
  },
  agentName: {
    fontSize: 12,
    color: 'gray',
  },
  ...GlobalStyles,
});
